import React from 'react';
import { AdditionalType, Tourney } from '../../model/interfaces';
import PendingTournamentAdditional from '../pendingTournaments/pendingAdditional/pendingTournamentAdditional';
import { FinishedTournamentAdditional } from '../finishedTournaments/finishedAdditional/finishedTournamentAdditional';
import { InProgressTournamentAdditional } from '../inProgressTournaments/inProgressTournamentAdditional/inProgressTournamentAdditional';

export default function TournamentsAdditionalInfo(props: {
  addData: AdditionalType;
  tournament?: Tourney;
}) {
  const { component } = props.addData;
  return (
    <div className="additional-wrap">
      {component === 'inProgress' ? (
        <InProgressTournamentAdditional data={props.addData} />
      ) : component === 'pending' && props.tournament ? (
        <PendingTournamentAdditional data={props.addData} tournament={props.tournament}/>
      ) : component === 'finished' ? (
        <FinishedTournamentAdditional data={props.addData} />
      ) : null}
    </div>
  );
};

export const months = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function startIn(dateString: string): number {
  const regex = /^(\w+)\s+(\d{1,2})\s+(\d{4})\s+(\d{1,2}):(\d{1,2})\s*([A|P]M)$/;
  const match = regex.exec(dateString);
  if (match != null) {
    const timeShift = match[6] === 'AM' ? 0 : 12;
    const date = new Date(
      parseInt(match[3], 10), //year
      getMonthFromString(match[1]), //month
      parseInt(match[2], 10), //day
      parseInt(match[4], 10) + timeShift, //hours
      parseInt(match[5], 10) //minutes
    );
    return date.getTime() - date.getTimezoneOffset() * 60 * 1000;
  }
  return new Date().getTime();
}

function getMonthFromString(mon: string) {
  const d = Date.parse(mon + '1, 2012');
  return new Date(d).getMonth();
}
